<!--
   Created by qing on 2020/2/19 1:33 下午
   Des:
-->
<template>
  <div
    v-if="filterWay"
    class="filter-content">
    <template v-if="filter.method === FILTER_METHOD_TYPE__RANGE">
      <van-field
        v-model.number="filter.value[0]"
        type="number"
        placeholder="请输入最小值"/>
      <van-field
        v-model.number="filter.value[1]"
        type="number"
        placeholder="请输入最大值"/>
    </template>
    <template v-else>
      <van-field v-model.number="filter.value[0]" type="number" placeholder="请输入筛选值"/>
    </template>
  </div>

  <van-field
    v-else
    type="number"
    :disabled="disabled"
    :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
    @change="valueChange"
    v-model.number="current[0]"
    :placeholder="field.fieldDes">
  </van-field>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    },
    computed: {
      numberValue: {
        set(newVal) {
          this.current[0] = newVal
            .replace(/[^\d.]/g, "")   // 清除“数字”和“.”以外的字符
            .replace(/^\./g, "")      // 验证第一个字符是数字而不是.
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
        },
        get() {
          return this.current[0]
        }
      }
    },
    methods: {
      valueChange() {
        this.current[0] = Number(this.current[0])
        this.filterChange()
      }
    }
  };
</script>

<style lang="less">

</style>
